export default "__VITE_ASSET__D8_F$9L8__"